import { loadingManagerEpicFactory } from 'modules/loading-manager/loading-manager.epics';

// constants
import { IP_LOCATION_SET_DATA } from 'modules/IP-location/IP-location.constants';
import { APPLY_LANGUAGE } from 'modules/language-provider/language-provider.constants';
import { INITIALIZE_UBISOFT_CONNECT_DONE } from 'modules/ubisoft-connect-provider/ubisoft-connect-provider.constants';
import {
    LOAD_UBISOFT_OVERLAY_DONE, INITIALIZE_UBISOFT_OVERLAY_DONE
} from 'modules/ubisoft-connect-overlay-provider/ubisoft-connect-overlay-provider.constants';

const loadingEpic = loadingManagerEpicFactory({
    modeAgnostic: [
        IP_LOCATION_SET_DATA,
        APPLY_LANGUAGE,
        INITIALIZE_UBISOFT_CONNECT_DONE,
        LOAD_UBISOFT_OVERLAY_DONE,
        INITIALIZE_UBISOFT_OVERLAY_DONE
    ],
    standalone: [
    ]
});

export default loadingEpic;
